import axios from '../axios';
import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';

const ACTIONS_MASTER = {
    GET_YEAR_SUCCESS: 'GET_YEAR_SUCCESS',
    GET_YEAR_ERROR: 'GET_YEAR_ERROR',
    GET_MASTER_GAME_SUCCESS: 'GET_MASTER_GAME_SUCCESS',
    GET_MASTER_GAME_ERROR: 'GET_MASTER_GAME_ERROR',
    GET_MASTER_TEAM_SUCCESS: 'GET_MASTER_TEAM_SUCCESS',
    GET_MASTER_TEAM_ERROR: 'GET_MASTER_TEAM_SUCCESS'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getYearData = () => {
    let url = `${host.serverTest}api/masters/years`;
    return async (dispatch) => {
        try {
            const { data } = await axios.get(url);
            let dataResponse = [];
            for (let i = 0; i < data.length; i++) {
                dataResponse.push({
                    year_id: data[i].id,
                    year: data[i].name
                })
            }
            dispatch(updateStatus(ACTIONS_MASTER.GET_YEAR_SUCCESS, dataResponse));
            return dataResponse;
        } catch (e) {
            dispatch(updateStatus(ACTIONS_MASTER.GET_YEAR_ERROR, e));
        }
        await axios.get(url);
    };
};

const getYearSeasonRangeData = () => {
    let url = `${host.serverTest}api/masters/years_seasonranges`;
    return async (dispatch) => {
        try {
            const { data } = await axios.get(url);
            let dataResponse = [];
            for (let i = 0; i < data.length; i++) {
                dataResponse.push({
                    year_id: data[i].id,
                    year: data[i].name,
                    start_date: data[i].start_date,
                    end_date: data[i].end_date
                })
            }
            dispatch(updateStatus(ACTIONS_MASTER.GET_YEAR_SUCCESS, dataResponse));
            return dataResponse;
        } catch (e) {
            dispatch(updateStatus(ACTIONS_MASTER.GET_YEAR_ERROR, e));
        }
        await axios.get(url);
    };
};

const getMasterGame = (current_date) => {

    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/masters/games?current_date=${current_date}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_MASTER.GET_MASTER_GAME_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_MASTER.GET_MASTER_GAME_ERROR, err));
            });
    };
}

const getMasterTeam = (team_id) => {
    let url = `${host.serverTest}api/masters/teams/${team_id}`;
    return async (dispatch) => {
        try {
            const { data } = await axios.get(url);
            dispatch(updateStatus(ACTIONS_MASTER.GET_MASTER_TEAM_SUCCESS, data));
            return data;
        } catch (err) {
            dispatch(updateStatus(ACTIONS_MASTER.GET_MASTER_TEAM_ERROR, err));
        }
    };
};


export {
    ACTIONS_MASTER, getYearData, getYearSeasonRangeData, getMasterGame, getMasterTeam
};